import { useEffect } from "react";

interface LightboxProps {
  images: string[];
  index: number;
  title: string;
  onClose: () => void;
  onNav: (next: number) => void;
}

export default function Lightbox({ images, index, title, onClose, onNav }: LightboxProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(index + 1);
      if (e.key === "ArrowLeft") onNav(index - 1);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [index, onClose, onNav]);

  const total = images.length;
  const current = ((index % total) + total) % total;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-foreground-950/90 p-4 animate-fade"
      onClick={onClose}
    >
      <button
        type="button"
        aria-label="关闭预览"
        onClick={onClose}
        className="absolute right-4 top-4 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-background-50/15 text-background-50 transition-colors hover:bg-background-50/25 md:right-8 md:top-8"
      >
        <i className="ri-close-line text-2xl"></i>
      </button>

      <button
        type="button"
        aria-label="上一张"
        onClick={(e) => {
          e.stopPropagation();
          onNav(current - 1);
        }}
        className="absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-50/15 text-background-50 transition-colors hover:bg-background-50/25 md:left-8 md:h-12 md:w-12"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>

      <figure className="max-h-[85vh] max-w-[90vw]" onClick={(e) => e.stopPropagation()}>
        <img
          src={images[current]}
          alt={`${title} 剧照 ${current + 1}`}
          title={`${title} - 金桔影院剧照`}
          className="max-h-[78vh] w-auto rounded-lg object-contain"
        />
        <figcaption className="mt-3 text-center text-sm text-background-200">
          {title} · 图集预览 {current + 1} / {total}
        </figcaption>
      </figure>

      <button
        type="button"
        aria-label="下一张"
        onClick={(e) => {
          e.stopPropagation();
          onNav(current + 1);
        }}
        className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-50/15 text-background-50 transition-colors hover:bg-background-50/25 md:right-8 md:h-12 md:w-12"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>
    </div>
  );
}